<template>
  <b-container fluid class="m-0 p-0">
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <div class="vertical-center ml-0 mr-0 width-max-content">
            <div class="mb-0 custom-card-header-text">
              {{ $cte("cashFlow.lastUploads") }}
            </div>
          </div>
          <div class="vertical-center ml-0 mr-0 width-max-content">
            <b-button
              variant="primary"
              class="d-flex align-items-center justify-content-center"
              @click="goToFileUpload('CASH_FLOW')"
            >
              <i class="fas fa-plus mt-1"></i>
              <span class="d-none d-lg-inline-block ml-2 mt-1">{{
                  $cte("cashFlow.newInvoice")
                }}</span>
            </b-button>
          </div>
        </div>
        <InvoiceView
          detail-view="/app/cashflow-detail"
          type="CASH_FLOW"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import InvoiceView from "@/components/InvoiceView";

export default {
  name: "CashFlowList",
  components: {
    InvoiceView,
  },
  props: {
    cashFlowOptions: {
      type: Object,
    },
  },
  methods: {

    goToFileUpload(resourceType) {
      this.$router.push({
        path: "/app/cashflow/fileUpload",
        query: {resourceType},
      });
    },
  },
};
</script>

<style scoped></style>
